import { useContext } from "react"
import { YAxisContext } from "./YAxisContext"
import type { YAxisContextValue } from "./YAxisContextValue"

export function useYAxisContext(): YAxisContextValue {
  return useContext(YAxisContext)
}
